export default "__VITE_ASSET__BDjq2P44__"